const PRICING_REGEX = /%pricing_[^ ]+%/g

// Pattern for replacement %pricing_<planIndex>_<key>%
// Example: %pricing_0_startingPrice% -> $10
export const replacePricings = (text, pricing) => {
  if (!pricing || !pricing.plans) {
    console.error('No pricing data provided to replace pricings')
    return text
  }

  return text.replace(PRICING_REGEX, match => {
    const paramStr = match.replace(/%/g, '')

    const [, planIndex, key] = paramStr.split('_')

    if (pricing.plans[planIndex] && pricing.plans[planIndex][key]) {
      return pricing.plans[planIndex][key]
    } else {
      console.log(`No value found for index ${planIndex} and key ${key}`)
      return ''
    }
  })
}
